import { get } from 'svelte/store';
import { activeAnimation, animationQueue, peerRole } from '../svelte/store.js';
import { PeerSync } from '../peer-sync.js';
import { createAnimationController } from './animation-controller.js';

let initializeAnimation = null;

const controller = createAnimationController({
  onChange(active, queue) {
    activeAnimation.set(active);
    animationQueue.set(queue);
  }
});

export function setAnimationInitializer(initializer) {
  initializeAnimation = typeof initializer === 'function' ? initializer : null;
}

export function triggerAnimation(payload, { forward = true } = {}) {
  const accepted = controller.trigger(payload, { initialize: initializeAnimation });
  if (accepted && forward && get(peerRole) === 'scorer' && PeerSync.isConnected) {
    try { PeerSync.sendAnim(payload); } catch (_) {}
  }
  return accepted;
}

export function advanceAnimation(now = Date.now()) {
  return controller.advance(now, initializeAnimation);
}

export function clearAnimations() {
  controller.clear();
}

export function getActiveAnimation() {
  return controller.getActive();
}

export function getAnimationQueue() {
  return controller.getQueue();
}

export function setActiveAnimation(value) {
  controller.setActive(value);
}

export function setAnimationQueue(value) {
  controller.setQueue(value);
}
